module.exports = {"130302001":"文化路街道","130302002":"海滨路街道","130302003":"北环路街道","130302004":"建设大街街道","130302005":"河东街道","130302006":"西港路街道","130302007":"燕山大街街道","130302008":"港城大街街道","130302009":"东环路街道","130302010":"白塔岭街道","130302100":"东港镇","130302101":"海港镇","130302102":"西港镇","130302103":"海阳镇","130302104":"北港镇","130302105":"杜庄镇","130302106":"石门寨镇","130302107":"驻操营镇","130302403":"临港物流园区","130302404":"海港经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130302.json
// module id = 100
// module chunks = 0